<ngx-spinner [fullScreen]="true" type="" size="medium" bdColor="rgba(0, 0, 0, 0)">
    <img style="width: 100px;" src="/assets/img/wheel.svg" alt="Girl in a jacket" width="100px" height="100px" >
    </ngx-spinner>